import { NavLink, Outlet, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const linkClass = ({ isActive }) =>
    `op-label block w-full px-4 py-3 border-l-2 transition-colors duration-150 ${
        isActive
            ? "border-t2bb6ff text-tffffff bg-t2bb6ff/5"
            : "border-transparent text-t8f95a3 hover:text-tffffff hover:bg-t1a1d24"
    }`;

// Promemoria automatico: giocatori TM-only finiti in rosa ma ancora da completare.
function TmPendingBanner() {
    const [data, setData] = useState(null);
    const [busyPid, setBusyPid] = useState(null);
    useEffect(() => {
        api.get("/tm-age/tm-only-pending").then((r) => setData(r.data)).catch(() => {});
    }, []);
    const dismiss = async (pid) => {
        if (!window.confirm("Escludere questo Agri senza scheda PESDB dalla lista 'TM da completare'? (reversibile)")) return;
        setBusyPid(pid);
        try {
            await api.post(`/tm-age/tm-only-pending/${pid}/dismiss`);
            setData((d) => d ? {
                ...d,
                items: d.items.filter((x) => x.pes_id !== pid),
                count: Math.max(0, (d.count || 1) - 1),
                completed: (d.completed || 0) + 1,
            } : d);
        } catch { /* ignore */ } finally { setBusyPid(null); }
    };
    if (!data || !data.count) return null;
    return (
        <div className="mb-6 op-card p-4 border-l-4" style={{ borderLeftColor: "rgb(var(--tc-ff7a1a))" }} data-testid="tm-pending-banner">
            <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="op-heading text-base" style={{ color: "rgb(var(--tc-ff7a1a))" }}>
                    ⚠️ {data.count} {data.count === 1 ? "giocatore TM da completare" : "giocatori TM da completare"}
                </div>
                <Link to="/admin/tm-age" className="op-mono text-[11px] text-t2bb6ff hover:underline shrink-0">
                    Giro età TM ↗
                </Link>
            </div>
            {data.total > 0 && (
                <div className="mt-2" data-testid="tm-pending-progress">
                    <div className="flex items-center justify-between op-mono text-[11px] mb-1">
                        <span className="text-t7ce38b">Completati {data.completed}/{data.total}</span>
                        <span className="text-t8f95a3">{Math.round((data.completed / data.total) * 100)}%</span>
                    </div>
                    <div className="h-1.5 bg-t22252a overflow-hidden rounded-full">
                        <div
                            className="h-full bg-t7ce38b transition-all duration-500"
                            style={{ width: `${(data.completed / data.total) * 100}%` }}
                        />
                    </div>
                </div>
            )}
            <p className="op-mono text-[11px] text-t8f95a3 mt-1">
                Giocatori solo-Transfermarkt acquistati all&apos;asta: aprine la scheda per completare nome / VG / valore / età.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
                {data.items.map((p) => (
                    <span
                        key={p.pes_id}
                        className="inline-flex items-stretch border border-tff7a1a/40"
                        data-testid={`tm-pending-row-${p.pes_id}`}
                    >
                        <Link
                            to={`/giocatori/${p.pes_id}`}
                            className="op-mono text-[11px] px-2.5 py-1.5 text-tffffff hover:bg-tff7a1a/10 transition-colors"
                            data-testid={`tm-pending-item-${p.pes_id}`}
                            title={`Mancano: ${(p.missing || []).join(", ") || "—"}`}
                        >
                            <span className="text-tff7a1a">{p.team_name || "—"}</span> · {p.name}
                            {p.missing && p.missing.length > 0 && (
                                <span className="text-t5c6370"> · manca {p.missing.join(", ")}</span>
                            )}
                        </Link>
                        <button
                            onClick={() => dismiss(p.pes_id)}
                            disabled={busyPid === p.pes_id}
                            className="op-mono text-[11px] px-2 border-l border-tff7a1a/40 text-tff5c5c hover:bg-tff5c5c/10 transition-colors disabled:opacity-40"
                            title="Agri senza scheda PESDB: togli dalla lista (nessun VG richiesto)"
                            data-testid={`tm-pending-dismiss-${p.pes_id}`}
                        >
                            ✕
                        </button>
                    </span>
                ))}
            </div>
        </div>
    );
}

export default function AdminLayout() {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="admin-layout">
            <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
                <div>
                    <div className="op-label text-t2bb6ff">// ADMIN CONSOLE</div>
                    <h1 className="op-heading text-5xl mt-3">Pannello <span className="op-gradient-text">CDP</span></h1>
                </div>
                <div className="op-mono text-t8f95a3 text-xs">
                    Consiglio dei Presidenti · Phase 1
                </div>
            </div>

            <TmPendingBanner />

            <div className="grid lg:grid-cols-[220px_1fr] gap-8">
                <aside className="op-card py-3 self-start lg:sticky lg:top-24 z-10">
                    <NavLink to="/admin" end className={linkClass} data-testid="admin-nav-overview">
                        Overview
                    </NavLink>
                    <NavLink to="/admin/users" className={linkClass} data-testid="admin-nav-users">
                        Utenti
                    </NavLink>
                    <NavLink to="/admin/divisions" className={linkClass} data-testid="admin-nav-divisions">
                        Divisioni
                    </NavLink>
                    <NavLink to="/admin/calendario" className={linkClass} data-testid="admin-nav-calendario">
                        Calendario
                    </NavLink>
                    <NavLink to="/admin/tavolini" className={linkClass} data-testid="admin-nav-tavolini">
                        Tavolini
                    </NavLink>
                    <NavLink to="/admin/disciplinare" className={linkClass} data-testid="admin-nav-disciplinare">
                        Disciplinare
                    </NavLink>
                    <NavLink to="/admin/assenze" className={linkClass} data-testid="admin-nav-assenze">
                        Assenze
                    </NavLink>
                    <NavLink to="/admin/teams" className={linkClass} data-testid="admin-nav-teams">
                        Squadre
                    </NavLink>
                    <NavLink to="/admin/mercato" className={linkClass} data-testid="admin-nav-mercato">
                        Mercato
                    </NavLink>
                    <NavLink to="/admin/svincolati" className={linkClass} data-testid="admin-nav-svincolati">
                        Svincolati
                    </NavLink>
                    <NavLink to="/admin/statistiche-mercato" className={linkClass} data-testid="admin-nav-statistiche-mercato">
                        Statistiche Mercato
                    </NavLink>
                    <NavLink to="/admin/doppioni-aste" className={linkClass} data-testid="admin-nav-doppioni-aste">
                        Doppioni Aste
                    </NavLink>
                    <NavLink to="/admin/injuries" className={linkClass} data-testid="admin-nav-injuries">
                        Infortuni
                    </NavLink>
                    <NavLink to="/admin/cina" className={linkClass} data-testid="admin-nav-cina">
                        🌏 Cina/Arabia
                    </NavLink>
                    <NavLink to="/admin/obblighi" className={linkClass} data-testid="admin-nav-obblighi">
                        Obblighi Riscatto
                    </NavLink>
                    <NavLink to="/admin/wages" className={linkClass} data-testid="admin-nav-wages">
                        Stipendi
                    </NavLink>
                    <NavLink to="/admin/stadi" className={linkClass} data-testid="admin-nav-stadi">
                        Stadi
                    </NavLink>
                    <NavLink to="/admin/primavera" className={linkClass} data-testid="admin-nav-primavera">
                        Primavera
                    </NavLink>
                    <NavLink to="/admin/regulation" className={linkClass} data-testid="admin-nav-regulation">
                        Regolamento
                    </NavLink>
                    <NavLink to="/admin/pesdb" className={linkClass} data-testid="admin-nav-pesdb">
                        PES DB Sync
                    </NavLink>
                    <NavLink to="/admin/pesdb-link" className={linkClass} data-testid="admin-nav-pesdb-link">
                        Aggancia PESDB
                    </NavLink>
                    <NavLink to="/admin/pesdb-relink" className={linkClass} data-testid="admin-nav-pesdb-relink">
                        Ri-aggancia PESDB
                    </NavLink>
                    <NavLink to="/admin/pesdb-audit" className={linkClass} data-testid="admin-nav-pesdb-audit">
                        Giocatori non-standard
                    </NavLink>
                    <NavLink to="/admin/update-requests" className={linkClass} data-testid="admin-nav-update-requests">
                        Richieste agg. TM/PESDB
                    </NavLink>
                    <NavLink to="/admin/counterparty-audit" className={linkClass} data-testid="admin-nav-counterparty-audit">
                        Controllo contropartite
                    </NavLink>
                    <NavLink to="/admin/budget-reconciliation" className={linkClass} data-testid="admin-nav-budget-reconciliation">
                        Quadratura Budget
                    </NavLink>
                    <NavLink to="/admin/prizes-import" className={linkClass} data-testid="admin-nav-prizes-import">
                        Importa Premi
                    </NavLink>
                    <NavLink to="/admin/tm-age" className={linkClass} data-testid="admin-nav-tm-age">
                        Età Transfermarkt
                    </NavLink>
                    <NavLink to="/admin/featured-links" className={linkClass} data-testid="admin-nav-featured-links">
                        Il mondo di OP
                    </NavLink>
                    <NavLink to="/admin/legacy" className={linkClass} data-testid="admin-nav-legacy">
                        Import Legacy
                    </NavLink>
                    <NavLink to="/admin/annunci" className={linkClass} data-testid="admin-nav-annunci">
                        Annunci
                    </NavLink>
                    <NavLink to="/admin/telegram" className={linkClass} data-testid="admin-nav-telegram">
                        Telegram
                    </NavLink>
                    <NavLink to="/admin/db-migration" className={linkClass} data-testid="admin-nav-db-migration">
                        Migrazione DB
                    </NavLink>
                </aside>

                <main className="op-card p-6 min-h-[60vh]">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
